// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-upload[data-v-f83dee0c] {\n  --magic-box-background: #452970;\n  --magic-file-upload-header-dark-transparent: #3a225d;\n  background-color: transparent;\n  color: var(--magic-light, #fff);\n}\n\n.files[data-v-f83dee0c] {\n  --magic-file-upload-files-dark-transparent: #3a225d;\n}\n\n.file-drop[data-v-f83dee0c] {\n  background-color: transparent;\n}\n\n.header[data-v-f83dee0c] {\n  color: var(--magic-light, #fff);\n}", ""]);
// Exports
module.exports = exports;
